<script lang="ts" module>
	export interface ContainerProps {
		id?: string;
		class?: string;
		style?: string;
		component?: string;
		dataCy: string;
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { id, component = 'section', dataCy, children, ...rest }: ContainerProps = $props();
</script>

<svelte:element
	this={component}
	{id}
	data-cy={dataCy}
	style={rest.style}
	class={twMerge('container mx-auto max-w-screen-xl px-4 sm:px-6', rest.class)}
>
	{@render children?.()}
</svelte:element>
